import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AnimeSearch from './features/anime/AnimeSearch';
import AnimeDetail from './features/anime/AnimeDetail';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AnimeSearch />} />
        <Route path="/anime/:id" element={<AnimeDetail />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;